module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [{
        open: _vm.open
      },
      'sky-accordion' ],
    attrs: {
      "aria-controls": _vm.id
    }
  }, [_c('button', {
    staticClass: "title",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("title"), _vm._v(" "), _c('sky-svg', {
    attrs: {
      "name": "wedge"
    }
  })], 2), _vm._v(" "), _c('sky-reveal', {
    attrs: {
      "open": _vm.open
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-7d9db302"}!./scripts/sky-accordion/sky-accordion.html
// module id = 378
// module chunks = 1